import React, { useCallback, useState } from "react";

import { translationService } from "../../../services/translation/TranslationService";
import useThemeService from "../../../services/theme-service/ThemeService";
import { BatchAnalysisStatusItem } from "../../../services/batch-processing/BatchAnalysisStatusItem";
import Svg from "../../svg/Svg";
import DataGrid from "../../datatable/DataGrid";
import { batchVideoAnalysisService } from "../../../services/batch-processing/BatchVideoAnalysisService";
import { batchHighlightDetectionService } from "../../../services/batch-processing/BatchHighlightDetectionService";
import { Collapse as CollapseIcon } from "../../svg/svgImageList";
import { BatchProcessingInstance } from "../../../services/batch-processing/BatchProcessingStatusModel";

export enum BatchProcessingType {
  VideoAnalysis = 0,
  HighlightDetection = 1,
}

interface StatusTableRowProps {
  batchProcessingType: BatchProcessingType;
}

export const StatusTableHeader = () => {
  return (
    <tr>
      <th className="table-item">
        {translationService.translate("damages.BatchProcessingStatus.started")}
      </th>
      <th className="table-item"> {translationService.translate("general.projects.name")} </th>
      <th className="table-item"> {translationService.translate("general.files")} </th>
      <th className="table-item">
        {translationService.translate("damages.BatchProcessingStatus.analyzed")}
      </th>
      <th className="table-item">{translationService.translate("general.failed")}</th>
    </tr>
  );
};

export const StatusTableRow = (props: StatusTableRowProps) => {
  const { themeClass } = useThemeService();

  const batchProcessingService =
    props.batchProcessingType === BatchProcessingType.VideoAnalysis
      ? batchVideoAnalysisService
      : batchHighlightDetectionService;

  batchProcessingService.statusModel.batchProcessingInstances.forEach(
    (instance: BatchProcessingInstance, index) => {
      const currentInstanceItems =
        batchProcessingService.statusModel.batchResultsStorage.data?.items.filter(
          (item: BatchAnalysisStatusItem) => instance.videoIds.includes(item.videoId)
        );

      batchProcessingService.statusModel.addInstanceResultStorage(currentInstanceItems, index);
    }
  );

  const [openStatusDataGrids, setOpenStatusDataGrids] = useState(
    new Array(batchProcessingService.statusModel.batchProcessingInstances.length).fill(false)
  );

  const handleOpenStatusDataGrid = useCallback(
    (index: number) => {
      const updatedOpenStatuses = [...openStatusDataGrids];
      updatedOpenStatuses[index] = !updatedOpenStatuses[index];
      setOpenStatusDataGrids(updatedOpenStatuses);
    },
    [openStatusDataGrids]
  );

  return (
    <>
      {batchProcessingService.statusModel.batchProcessingInstances.map(
        (x: BatchProcessingInstance, index) => (
          <>
            <tr>
              <td className="table-item">
                {x?.startedAt.toLocaleTimeString("en-US", {
                  hour12: false,
                })}
              </td>
              <td className="table-item">{x?.projectName}</td>
              <td className="table-item">{x?.videoIds.length}</td>
              <td className="table-item">
                {batchProcessingService.statusModel.getSuccessfullyCountForVideoIds(x?.videoIds)}
              </td>
              <td className="table-item">
                {batchProcessingService.statusModel.getFailedCountForVideoIds(x?.videoIds)}
                <span className="drop-down-arrow" onClick={() => handleOpenStatusDataGrid(index)}>
                  <Svg
                    svg={CollapseIcon}
                    className={themeClass(
                      ["secondary-menu-collapse"],
                      [openStatusDataGrids[index] ? "down-status-arrow" : "up-status-arrow"]
                    )}
                  />
                </span>
              </td>
            </tr>

            {openStatusDataGrids[index] && (
              <DataGrid
                itemTypeKey="status"
                dataGridStorage={batchProcessingService.statusModel.instancesResultsStorages[index]}
                withTopSpacing
                noSelection
                insideDialog
                isStatusDropdownTable={true}
              />
            )}
          </>
        )
      )}
    </>
  );
};
